import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch, useHistory, useLocation } from "react-router-dom";

import { deactivateIntegration } from 'actions/integrations/integrations';
import _ from 'lodash';
import {
  Row,
  Col,
  Button,
  Image,
} from "react-bootstrap";

import { HubspotAuthentication } from './hubspotAuthentication';

import styles from './hubspot.module.scss';

import { getBaseUrl } from 'services/util';
import { HubspotConfiguration } from './hubspotConfiguration';

export const HubSpotIntegration = () => {
  const dispatch = useDispatch();

  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);
  const location = useLocation()
  const history = useHistory()

  const deactivating = useSelector(state => _.get(state, 'integrations.activated.deactivating', false));
  const authenticating = useSelector(state => _.get(state, "integrations.hubspot.authentication.authenticating", false))

  const integrationData = location.state;

  const integrations = useSelector(state => _.get(state, 'integrations.activated.items', []));
  const integration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type == 'hubspot';
  });

  const handleBackClick = () => {
    var url = `${baseUrl}/integration-settings/integration`;
    history.push(url);
  }

  const handleDeleteClick = () => {
    dispatch(deactivateIntegration('hubspot', (res) => {
      handleBackClick();
    }))
  }

  var isAuthenticated = false;

  if (integration && integration.state.code === "ok" && !integration.error) {
    isAuthenticated = true;
  }

  return (
    <div className={styles.hubspotContent}>
      <Button variant='light' onClick={handleBackClick} className={styles.backButton} >
        <i className="cleverstory-left" />
        Back
      </Button>
      <div className={styles.formContainer}>
        <Row className={styles.cardWrapper}>
          <Col className={styles.integrationDetail} md={5}>
            <div className={styles.logoContainer}>
              <Image src={integrationData.logo} />
            </div>
            <div className={styles.detailContainer}>
              <span className={styles.title}>{integrationData && integrationData.title}</span>
              <span className={styles.description}>{integrationData && integrationData.description}</span>
              {isAuthenticated && <Button variant='secondary' onClick={handleDeleteClick} className={styles.deactivateButton} >{deactivating ? 'Deactivating...' : 'Deactivate'}</Button>}
              {!isAuthenticated && <span className={styles.inactiveStatus}>INACTIVE</span>}
            </div>
          </Col>
          <Col className={styles.authForm} md={7}>
            {!isAuthenticated &&
              <HubspotAuthentication authenticated={authenticating} />
            }
            {isAuthenticated &&
              <HubspotConfiguration isAuthenticated={isAuthenticated} />
            }
          </Col>
        </Row>
      </div>
    </div>
  )
}